import { Variant } from '@/models/webshop.model';

export const normalizeUnit = (unit: Variant['unitOfMeasure'] | null): string => {
  if (!unit) {
    return '';
  }
  const lower = unit.toLowerCase();
  if (lower.includes('milliliter') || lower.includes('millilitre')) {
    return 'ml';
  }
  return unit;
};

export const formatVariantLabel = (variant: Variant | null): string => {
  if (!variant) {
    return '';
  }
  const size = variant.packSize;
  const packUnit = variant.packUnit ?? '';
  const uomRaw = variant.unitOfMeasure ?? '';
  const qty = variant.unitQuantity as number | null | undefined;

  const hasPackKeys =
    Object.prototype.hasOwnProperty.call(variant, 'packSize') &&
    Object.prototype.hasOwnProperty.call(variant, 'packUnit');
  const hasUnitKeys =
    Object.prototype.hasOwnProperty.call(variant, 'unitQuantity') &&
    Object.prototype.hasOwnProperty.call(variant, 'unitOfMeasure');

  const hasPack = hasPackKeys && size !== null && typeof size !== 'undefined' && String(packUnit).trim() !== '';
  const hasUnit = hasUnitKeys && qty !== null && typeof qty !== 'undefined' && String(uomRaw).trim() !== '';

  if (hasUnit) {
    const unitNorm = normalizeUnit(uomRaw);
    const unitWord = unitNorm.toLowerCase() === 'pieces' ? (qty === 1 ? 'Piece' : 'Pieces') : unitNorm;
    const hasPackSize = typeof size === 'number' && size > 1;
    if (hasPackSize) {
      return `${size} x ${qty} ${unitWord}`;
    }
    return `${qty} ${unitWord}`;
  }

  if (hasPack) {
    const labelUnit = packUnit.toLowerCase() === 'pieces' && size === 1 ? 'Piece' : packUnit;
    return `${size} ${labelUnit}`.trim();
  }

  return '';
};

export const sortVariantsForPackOptions = (variants: Variant[]): Variant[] => {
  const allMl = variants.length > 0 && variants.every((v) => normalizeUnit(v.unitOfMeasure ?? null) === 'ml');
  if (!allMl) {
    return variants;
  }
  return [...variants].sort((a, b) => (a.unitQuantity ?? 0) - (b.unitQuantity ?? 0));
};
